exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-from-ai-finance-jsx": () => import("./../../../src/pages/index-from-ai-finance.jsx" /* webpackChunkName: "component---src-pages-index-from-ai-finance-jsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-interactive-demo-jsx": () => import("./../../../src/pages/interactive-demo.jsx" /* webpackChunkName: "component---src-pages-interactive-demo-jsx" */)
}

